import React from 'react';
import { Calendar, Badge, Popover, Button } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const FlightCalendarView = ({ flights, onShowDetails }) => {

    const getListData = (value) => {
        const dateStr = value.format('YYYY-MM-DD');
        const listData = flights
            .filter(flight => dayjs.utc(flight.flight_date).format('YYYY-MM-DD') === dateStr)
            .map(flight => ({
                type: getStatusBadgeType(flight.status),
                content: `${flight.flight_number} (${flight.departure_airport}-${flight.arrival_airport}) ${dayjs.utc(flight.std).format('HH:mm')}Z`,
                flight: flight // Pass flight object
            }));
        return listData || [];
    };

    const getStatusBadgeType = (status) => {
        switch (status) {
            case 'COMPLETED': return 'success';
            case 'DELAYED': return 'warning';
            case 'CANCELLED': return 'error';
            case 'ACTIVE': return 'processing';
            default: return 'default';
        }
    };

    const dateCellRender = (value) => {
        const listData = getListData(value);
        return (
            <ul className="events" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                {listData.map((item, index) => (
                     <li key={`${item.flight.id}-${index}`}>
                       <Popover
                            content={(
                                <div>
                                    <p>{item.content}</p>
                                    <Button type="link" size="small" onClick={() => onShowDetails(item.flight)}>
                                        查看事务
                                    </Button>
                                </div>
                            )}
                            title={`航班: ${item.flight.flight_number}`}
                            trigger="hover"
                        >
                            <Badge status={item.type} text={item.content} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}/>
                        </Popover>
                    </li>
                ))}
            </ul>
        );
    };

    // Ant Design Calendar v5 uses cellRender instead of dateCellRender
    // Check your antd version and use the appropriate prop
    return <Calendar cellRender={dateCellRender} /* dateCellRender={dateCellRender} for older versions */ />;
};

export default FlightCalendarView;
